"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formControlClasses = exports.formControlTypes = exports.formControlKeys = void 0;
exports.formControlKeys = {
    firstName: 'firstName',
    lastName: 'lastName',
    company: 'company',
    companyType: 'companyType',
    numberOfEmployees: 'numberOfEmployees',
    department: 'department',
    jobFunction: 'jobFunction',
    email: 'email',
    country: 'country',
    language: 'language',
    postalZipCode: 'postalZipCode',
    consentCheckbox: 'consentCheckbox',
    chineseConsentCheckbox: 'chineseConsentCheckbox',
    submitBtn: 'submitBtn',
};
exports.formControlTypes = {
    dropdown: 'dropdown',
    input: 'input',
    checkbox: 'checkbox',
    submit: 'submit',
    chineseCheckbox: 'chineseCheckbox',
};
exports.formControlClasses = {
    oneInARow: 'col-span-2 mb-4',
    twoInARow: 'col-span-1 mb-4',
    agreementBlock: 'agreement'
};
